import React from 'react';
import styles from '../Operations.module.css';

interface AH08Component extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

/**
 * AOSVALIDATE - AOS Validate Stock Within 15 Mins
 * KPI information component
 */
const AH08: AH08Component = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>Metric Description</div>

      <div className={styles.sectionContent}>
        AOS Validate Stock Within 15 minutes is used to indicate if an acehardware.com In-Store Pick
        order (fulfilled from store stock) was validated in AOS or ARMA within the required 15
        minutes from order notification (order creation).
      </div>

      <div className={styles.sectionTitle}>Supporting Details</div>

      <div className={styles.sectionContent}>
        When a customer places an online order for In-Store Pick, your associates receive a text,
        email, or push notification indicating an order is ready to be validated. A store must
        validate orders within 15 minutes to meet consumers&apos; expectations.
      </div>

      <div className={styles.sectionTitle}>Goal</div>

      <div className={styles.sectionContent}>
        Pinnacle Goal: Validate 85% of online orders &lt; 15 minutes
        <br />
        <br />
        Platinum Goal: Validate 75% of online orders &lt; 15 minutes
      </div>

      <div className={styles.sectionTitle}>Update Cadence</div>

      <div className={styles.sectionContent}>
        Metric is current state and updated monthly to reflect a rolling 12 months.
      </div>

      <div className={styles.sectionTitle}>Drill Down</div>

      <div className={styles.sectionContent}>
        Metric is current state and updated monthly to reflect a rolling 12 months bookended by
        year end.
        <br />
        <br />
        PINNACLE:
        <ul>
          <li>BOPIS, BODFS, Assembly AND</li>
          <li>&gt;85% .com orders validated &lt;15 minutes</li>
        </ul>
        PLATINUM:
        <ul>
          <li>BOPIS, BODFS, Assembly AND</li>
          <li>&gt;75% .com orders validated &lt;15 minutes</li>
        </ul>
      </div>

      <div className={styles.sectionTitle}>Learn More</div>

      <div className={styles.sectionContent}>
        Review this rate to ensure your store is validating acehardware.com orders as soon as
        possible for the consumer.
        <br />
        <br />
        By clicking on the hyperlink, you will see your store&apos;s count of In Store Pickup orders
        and how many of the orders were validated on time by month.
        <br />
        <br />
        This report is encouraged to be monitored monthly.
        <br />
        <br />
        For additional guidance review the Ace Way of Retailing{' '}
        <a
          href="https://acenet.aceservices.com/awor/acehardwarecom-order-management/customer-order-fulfillment"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
          Acehardware.com Order Fulfillment
        </a>
      </div>
    </div>
  );
};

AH08.title = 'AOS Validate Stock Within 15 Mins';
AH08.actionTitle = 'Order Details';
AH08.actionHyperlink = 'dynamicURL:WFC:current';
export default AH08;
